import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import { Box } from "@mui/material";
import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AdminCatalogTableRow } from "../../types";
import { useStyles } from "./styles";
import { useNavigate } from "react-router-dom";

type Props = {
  rows: AdminCatalogTableRow[] | [];
  loading?: boolean;
};

 const AdminCatalogTable = ({ rows, loading = false }: Props) => {
 const { t } = useTranslation();
 const styles = useStyles();
 const nav = useNavigate();

 const onClick = (row: AdminCatalogTableRow)=> nav(`/catalogs/${row.id}`, { state: row })
  
 



  const columns = useMemo(
    () => [
      {
        id: "visualIntegration",
        label: t("CATALOGS.TABLE.VISUAL_INTEGRATION"),
        minWidth: 140,
        align: "right",
        format: (row: AdminCatalogTableRow) =>
          t(`CATALOGS.VISUAL_INTEGRATION_VALUES.${row.visualIntegration}`),
      },
      {
        id: "mainInfluenceField",
        label: t("CATALOGS.TABLE.MAIN_INFLUENCE_FIELD"),
        minWidth: 140,
        align: "right",
        format:(row: AdminCatalogTableRow)=>
          t(`CATALOGS.INFLUENCE_FIELD_VALUES.${row.mainInfluenceField}`),
      },
      {
        id: "amountOfitems",
        label: t("CATALOGS.TABLE.AMOUNT_OF_ITEMS"),
        minWidth: 100,
        align: "right",
      },
      {
        id: "description",
        label: t("CATALOGS.TABLE.DESCRIPTION"),
        minWidth: 140,
        align: "right",
        format: (row: AdminCatalogTableRow) => t(row.description),
      },
      {
        id: "catalogName",
        label: t("CATALOGS.TABLE.CATALOG_NAME"),
        minWidth: 160,
        align: "right",
        format: (row: AdminCatalogTableRow) => t(row.catalogName),
      }
    ],
    [styles, t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows || []}
        columns={columns}
        loading={loading}
        onRowClick={onClick}
        serialEnabled={false}
        isPointerCursor
      />
    </div>
  );
};

export default AdminCatalogTable;
